import {
  IHttpApi,
  mergeBaseUri,
  mergePaths,
  transformObjectToQuery,
  IHTTPRequestConfig,
  IHTTPCompletedResponse,
} from '@cian/http-api';

import { IEditCommentRequest, IEditCommentConfig, TResponses } from './types';

const defaultConfig: Required<IEditCommentConfig> = {
  pathApi: '/v1/edit-comment',
  browserUrl: 'https://dev-cian.ru/content-api',
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const defaultRequest: IHTTPRequestConfig<any> = {
  uri: {
    host: '',
    path: '',
  },
  method: 'POST',
  requestType: 'formData',
  body: '',
  withCredentials: true,
  headers: [['Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8']],
};

function createEditCommentRequest({
  bodyParameters,
  queryParameters,
  config,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
}: Pick<IEditCommentOptions, 'bodyParameters' | 'queryParameters' | 'config'>): IHTTPRequestConfig<any> {
  const { pathApi, browserUrl } = { ...defaultConfig, ...config };

  return {
    ...defaultRequest,
    uri: mergeBaseUri(browserUrl, {
      path: (path: string) => mergePaths(path, pathApi),
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      query: transformObjectToQuery(queryParameters as any).unwrap() as any,
    }),
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    body: transformObjectToQuery(bodyParameters as any).unwrap() as any,
  };
}

export interface IEditCommentOptions {
  httpApi: IHttpApi;
  bodyParameters: IEditCommentRequest;
  queryParameters?: IEditCommentRequest;
  config?: IEditCommentConfig;
}

async function requestEditComment({
  httpApi,
  bodyParameters,
  queryParameters,
  config,
}: IEditCommentOptions): Promise<IHTTPCompletedResponse<TResponses>> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return httpApi.httpRequest(createEditCommentRequest({ bodyParameters, queryParameters, config })) as any;
}

export { defaultConfig, createEditCommentRequest, requestEditComment };
